(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recent-viewed-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.evelance-recently-viewed--compact';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const startCarousel = (section) => {
      if (section.dataset.evelanceAutoplayReady === 'true') return;

      const grid = section.querySelector('[data-grid-container]');
      const slides = section.querySelectorAll('.swiper-slide');
      if (!grid || slides.length < 2) return;

      section.dataset.evelanceAutoplayReady = 'true';
      let paused = false;

      section.addEventListener('pointerenter', () => { paused = true; });
      section.addEventListener('pointerleave', () => { paused = false; });
      section.addEventListener('focusin', () => { paused = true; });
      section.addEventListener('focusout', () => { paused = false; });
      section.addEventListener('touchstart', () => { paused = true; }, { passive: true });
      section.addEventListener('touchend', () => { paused = false; }, { passive: true });

      window.setInterval(() => {
        if (paused || document.hidden || reducedMotion.matches) return;

        if (grid.swiper && typeof grid.swiper.slideNext === 'function') {
          grid.swiper.slideNext();
          return;
        }

        if (window.innerWidth <= 767) {
          const firstSlide = section.querySelector('.swiper-slide');
          if (!firstSlide) return;

          const step = firstSlide.getBoundingClientRect().width + 12;
          const atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 8;
          grid.scrollTo({ left: atEnd ? 0 : grid.scrollLeft + step, behavior: 'smooth' });
        }
      }, 4500);
    };

    const initialize = () => {
      document.querySelectorAll(selector).forEach(startCarousel);
    };

    initialize();
    new MutationObserver(initialize).observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
